import { ViewDash } from "@/components/views/ViewDash";
import { ViewDetalhe } from "@/components/views/ViewDetalhe";
import { ViewLoading } from "@/components/views/ViewLoading";
import { ViewLogin } from "@/components/views/ViewLogin";
import { VIEWS } from "@/constants/views";
import { useAuth } from "@/contexts/auth";
import { useEffect } from "react"


function AdminPage() {
  const { user, view, setView, setUser, handleDetalhe, detalhe } = useAuth()

  useEffect(() => {
    const handlePopState = (event) => {
      if (view === VIEWS.VIEW_DETALHE) {
        setView(VIEWS.VIEW_DASH);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [view]);

  return (
    <>
      {view === VIEWS.VIEW_LOADING && <ViewLoading />}
      {view === VIEWS.VIEW_LOGIN && <ViewLogin setView={setView} setUser={setUser} />}
      {view === VIEWS.VIEW_DASH && <ViewDash setView={setView} handleDetalhe={handleDetalhe} />}
      {view === VIEWS.VIEW_DETALHE && <ViewDetalhe setView={setView} user={user} id={detalhe} />}
    </>
  )

}

export default AdminPage

